import { render, staticRenderFns } from "./PaginationSelect.vue?vue&type=template&id=b0fdbfea&scoped=true&"
import script from "./PaginationSelect.vue?vue&type=script&lang=js&"
export * from "./PaginationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fdbfea",
  null
  
)

export default component.exports